import moment from 'moment';

import { FileType } from '../../chat/utils/files';
import { DateFormat } from '../../utils/date';
import texts from './texts.json';

const FILTER_KEY = {
  ALL: 'ALL',
  PHOTOS: 'PHOTOS',
  VIDEOS: 'VIDEOS',
  FILES: 'FILES',
};

const TABLE_COLUMNS = [
  { className: 'name', label: texts.colName },
  { className: 'uploaded', label: texts.colUploaded },
  { className: 'menu', label: null },
];

const FILTERS = [
  { key: FILTER_KEY.ALL, label: texts.filterAll },
  { key: FILTER_KEY.PHOTOS, label: texts.filterPhotos },
  { key: FILTER_KEY.VIDEOS, label: texts.filterVideos },
  { key: FILTER_KEY.FILES, label: texts.filterPdfs },
];

const matchesFilter = (doc, filter) => {
  if (filter === FILTER_KEY.PHOTOS) return doc.type === FileType.IMAGE;
  if (filter === FILTER_KEY.VIDEOS) return doc.type === FileType.VIDEO;
  if (filter === FILTER_KEY.FILES) return doc.type === FileType.PDF || doc.type === FileType.FILE;
  return true;
};

const groupByMonth = (docs) => {
  const groups = new Map();
  docs.forEach((doc) => {
    const date = doc.uploadedAt;
    const key = date ? moment(date).format(DateFormat.YEAR_MONTH_DISPLAY_FORMAT) : 'Unknown';
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(doc);
  });
  return [...groups.entries()];
};

export {
  FILTER_KEY,
  FILTERS,
  TABLE_COLUMNS,
  matchesFilter,
  groupByMonth,
};
